import React from "react";
import { object, arrayOf } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { Button } from "../Button";
// eslint-disable-next-line import/no-cycle
import { CallToActionSections as CallToActionSectionsComponent } from "../../sharedComponents/CallToActionSections";
import * as styles from "./CallToActionSections.module.scss";

const CallToActionSections = ({ sections }) => (
	<CallToActionSectionsComponent sections={sections} customButton={Button} styles={styles} />
);

CallToActionSections.propTypes = {
	sections: arrayOf(object),
};
CallToActionSections.defaultProps = {
	sections: null,
};

export default CallToActionSections;
export { CallToActionSections };
